import { Capacitor } from '@capacitor/core';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  NgZone,
  OnInit,
} from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { IonicModule, Platform } from '@ionic/angular';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UserStore } from 'user.store';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { RecallService } from './services/recall.service';
import { register } from 'swiper/element/bundle';
import { Router } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { MenuNavigationService } from './services/menu-navigation.service';
import { HeaderDesktopComponent } from './components/header-desktop/header-desktop.component';
import { UtilsService } from './services/utils.service';
import { APP_CONSTANTS } from './app.constants';
import * as dayjs from 'dayjs';
import { Logger } from '@pfizer/newton-jetpack-utils';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    HeaderComponent,
    HeaderDesktopComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit {
  protected isDesktop = false;

  constructor(
    public platform: Platform,
    public translate: TranslateService,
    public logger: Logger,
    public userStore: UserStore,
    public ngZone: NgZone,
    public recallService: RecallService,
    public router: Router,
    protected menuNavigationService: MenuNavigationService,
    protected utilService: UtilsService
  ) {
    this.utilService.isDesktop =
      document.documentElement.clientWidth > APP_CONSTANTS.TABLET_MAX_WIDTH;
    this.utilService.device = this.utilService.getDeviceType();
    const localThis = this;
    window.addEventListener('resize', () => {
      localThis.utilService.isDesktop =
        document.documentElement.clientWidth > APP_CONSTANTS.TABLET_MAX_WIDTH;
      this.utilService.device = this.utilService.getDeviceType();
    });
  }

  public ngOnInit() {
    this.init();
    if (Capacitor.getPlatform() === 'web') {
      setTimeout(() => {
        if (environment.isExternal && !this.userStore.isHCP) {
          this.utilService.showHCPPopup();
        }
      }, 750);
    }
  }

  private async init() {
    this.logger.log(
      'this.userStore.eulaAcceptedOn..',
      this.userStore.eulaAcceptedOn
    );
    if (Capacitor.getPlatform() === 'web' || !environment.isExternal) {
      this.userStore.updateUser({
        eulaAcceptedOn: dayjs().toISOString(),
        isEulaAccepted: true,
      });
      this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.HOME);
    } else if (this.userStore.eulaAcceptedOn !== null) {
      this.utilService.selectedPage = APP_CONSTANTS.ROUTE_PATHS.HOME;
      this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.HOME);
    } else {
      this.utilService.selectedPage = APP_CONSTANTS.ROUTE_PATHS.TERMS_CONDITION;
      this.menuNavigationService.navigateByUrl(
        APP_CONSTANTS.ROUTE_PATHS.TERMS_CONDITION
      );
    }
    if (
      Capacitor.getPlatform() !== 'web' &&
      environment.isExternal &&
      !this.userStore.isHCP
    ) {
      this.utilService.showHCPPopup();
    }

    setTimeout(() => {
      SplashScreen.hide();
    }, 2000);
    await this.onAppOpen();
    this.subscribeToAppResumeEvents();
  }

  private subscribeToAppResumeEvents() {
    this.platform.resume.subscribe(async () => {
      await this.onAppOpen();
    });
  }

  private async onAppOpen() {
    // Run on each open event
    if (Capacitor.getPlatform() !== 'web' &&
      environment.isExternal) {
      this.recallService.checkAppRecallService();
    }
  }

  public refreshState() {
    this.logger.log('Refreshing state');
  }
}
